jQuery(function($) {
  
  $(document).ready(function() {
    
    accordionItem();
    ProductImagesGallery();
    ProductDescription();
    LinkedOptions();
  });
  
  
  
  $(window).on( 'load', function () {
    
  });
  
  
  
  $(window).on( 'resize', function () {
    
  });
  
  
  
  
  
  
  /*--------------------------------------------------
  jQuery Accordion
  https://github.com/vctrfrnndz/jquery-accordion
  ---------------------------------------------------*/	
  function accordionItem() {
    
    $('.accordion [data-accordion]').accordion({
      transitionSpeed: 300,                     // Transition speed on miliseconds.
      transitionEasing: "ease",                 // CSS value for easing.
      controlElement: "[data-control]",         // CSS selector for the element acting as a button.
      contentElement: "[data-content]",         // CSS selector for the element containing hide/show content.
      groupElement: "[data-accordion-group]",   // CSS selector for a parent element containing a group.
      singleOpen: true                          // Opens a single accordion a time.
    });
    
  }// accordionItem
  
  // Product Images swap with variant change
  function ProductImagesGallery() {
    let $form = document.querySelector('[data-product-form]');
    if ($form){
      let product = JSON.parse($form.dataset.productJson);
      let selected_variant = JSON.parse($form.dataset.selected_variant);
      product.selected_variant = selected_variant;
  
      document.addEventListener('variant:change', (e) => {
        e.preventDefault();
        let current_variant = e.detail.variant;
  
        if (!current_variant) return;
  
        if (product.selected_variant.id !== current_variant.id) {
          setTimeout(() => {
            product.selected_variant = current_variant;
            let url = `${ window.location.href }`;
            fetch(url)
              .then(res => res.text())
              .then((res) => {
                var $gallery = $(res).find('.product__images');
                $('.product__images').html($gallery.html());
                document.dispatchEvent(new CustomEvent('init-gallery'));
              });  
          }, 0);
        }
      });
    }
  }

  // Product Description swap with variant change
  function ProductDescription() {
    let $description = document.querySelector('.product-description');
    if ($description) {
      let option = JSON.parse($description.dataset.option);
      let option_id = 'option' + option.position;

      document.addEventListener('variant:change', (e) => {
        let current_variant = e.detail.variant;
        if (!current_variant) return;

        let option_value = current_variant[option_id];
        $description.querySelectorAll('.description').forEach(($desc) => {
          $desc.classList.toggle('hidden', $desc.dataset.value !== option_value);
        });
      });  
    }
  }

  function LinkedOptions() {
    let updateOptions = (product) => {
      let selected_values = [], $form = $(`#product_form_${ product.id }`);
      // If selections produce invalid variants, select first available variant
      if (!product.selected_variant) {
        let option_1_value = $form.find('[data-variant-option-index="0"] input:checked').val();
        let matching_variants = product.variants.filter(v => v.options.indexOf(option_1_value) !== -1);
        let matching_available_variants = product.variants.filter(v => v.options.indexOf(option_1_value) !== -1).filter(v => v.available);
        if (matching_variants.length) {
          let first_available_variant = matching_available_variants[0] || matching_variants[0];
          console.log({first_available_variant});
          first_available_variant.options.forEach((value, optIndex0) => {
            $form.find(`.swatch__option input[value="${ value }"]`).prop('checked', true);
            $form.find(`.swatch__option input[value="${ value }"]`)[0].dispatchEvent(new Event('change', {bubbles: true}));
            product.selected_variant = first_available_variant;
          });
        }
      }

      selected_values = product.selected_variant.options;
      product.options_with_values_variants.forEach((option) => {
        if (option.position > 1) {
          option.values_variants.forEach((value) => {
            let match_values = product.options_with_values.map((opt) => {
              if (opt.position < option.position) {
                return selected_values[(opt.position - 1)];
              }
              else {
                return value.value;
              }
            });
            let matching_variant = value.variants.find(v => _.isEqual(v.options, match_values));
            let $swatch = $form.find(`.swatch-element[data-value="${ value.value }"]`).closest('.swatch__option');
            //console.log(value, matching_variant, $swatch);

            $swatch.toggleClass('hide', !matching_variant);
            $swatch.toggleClass('soldout', matching_variant && !matching_variant.available);
          });
        }
      });

      setTimeout(() => {
        if (product.selected_variant) {
          product.selected_variant.options.forEach((value, optionIndex) => {
            $form.find(`.swatch[data-option-index="${ optionIndex }"] .options-selection__option-name span`).text(value);
          });
        }  
      }, 0);
    }

    document.querySelectorAll('[data-product-form]').forEach(($formWrap) => {
      let product = JSON.parse($formWrap.dataset.productJson);
      let options_with_values = JSON.parse($formWrap.dataset.options_with_values);
      product.options_with_values = options_with_values;
      let options_with_values_variants = options_with_values.map((option) => {
        let values_variants = option.values.map((value) => {
          return {
            value: value,
            variants: product.variants.filter(v => v.options.indexOf(value) !== -1)
          }
        });

        return {
          name: option.name,
          position: option.position,
          values_variants: values_variants
        }
      });
      product.options_with_values_variants = options_with_values_variants;

      let selected_variant = JSON.parse($formWrap.dataset.selected_variant);
      product.selected_variant = selected_variant;

      //console.log(product);

      // do linked options
      updateOptions(product);

      document.addEventListener('variant:change', (e) => {
        let selected_variant = e.detail.variant;
        product.selected_variant = selected_variant;
        updateOptions(product);  
      });
    });
  }
});

document.addEventListener('quizKitAddToCartSuccess', function (e) {
  SLIDECART_UPDATE();
  SLIDECART_OPEN();
}, false);



/*--------------------------------------------------
A11yDialog
https://github.com/edenspiekermann/a11y-dialog
---------------------------------------------------*/
(function () {
  document.addEventListener('DOMContentLoaded', function () {
  
    //var dialogEl = document.getElementById('info-dialog');
    //var mainEl = document.getElementById('main');
    //var dialog = new window.A11yDialog(dialogEl, mainEl);
  
  });
}());

function isAnyDialogShown() {
  //return !!$$('.dialog').filter(function(dialog) { return !dialog.getAttribute('aria-hidden'); }).length;
}





